<template>
  <div class="offers-list">
    <div class="row justify-content-center">
      <div
        class="col-sm col-md-6 col-lg-4 row-col"
        v-for="(value, index) in offers"
        :key="index"
      >
        <div class="row justify-content-center">
          <div class="card">
            <div style="position: relative">
              <img
                :src="value.image"
                class="card-img-top"
                :alt="value.name"
                @click="
                  pushImages(index, [
                    value.image,
                    value.image2 || '',
                    value.image3 || '',
                    value.image4 || ''
                  ])
                "
              />
              <div class="product-info">
                <div class="row justify-content-between">
                  <div class="col-3 col-sm-4">
                    <i class="fa fa-eye"></i> {{ value.threshhold }}
                  </div>
                  <div class="col-4 col-sm-4">
                    <i class="fas fa-check"></i> {{ value.quantity }}
                  </div>
                  <div class="col-5 col-sm-4">
                    <i class="fas fa-calendar-check"></i>
                    {{
                      value.completion_days >= 1
                        ? ` ${value.completion_days} Days`
                        : '0 Day'
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <h5 class="card-title">
                <router-link
                  class="product-link text-uppercase"
                  :to="`/products/${value.uuid}`"
                  >{{ value.name }}</router-link
                >
              </h5>
              <p class="card-text" v-if="value.community.value">
                Community: {{ value.community.value }}
              </p>
              <p class="card-text" v-if="value.region.value">
                Region: {{ value.region.value }}
              </p>
              <p class="card-text" v-if="value.region.value">
                Specifications:
                {{ value.specifications.specifications || 'N/A' }}
              </p>
              <hr />
              <p class="card-text" v-if="value.region.value">
                Start Date: {{ value.start_time | formatDateTime }}
              </p>
              <p class="card-text" v-if="value.region.value">
                Start Date: {{ value.end_time | formatDateTime }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CoolLightBox :items="activeImages" :index="index" @close="index = null">
    </CoolLightBox>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
export default {
  props: ['offers'],
  data() {
    return {
      activeImages: [],
      index: null
    }
  },
  components: {
    CoolLightBox
  },
  methods: {
    pushImages(imageIndex, images) {
      this.activeImages = images
      this.index = imageIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.card-img-top {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
.card {
  width: 90%;
  box-sizing: border-box;
  box-shadow: -2px 24px 30px -16px #c3c7c7;
}
.row-col {
  margin-bottom: 20px;
}
.product-link:hover {
  text-decoration: none;
}
.product-info {
  position: absolute;
  bottom: 0;
  background: #ff9a22;
  width: 100%;
  padding: 10px 20px;
  color: #fff;
  font-weight: bold;
}
.card-text {
  padding: 0;
  margin: 0;
}
</style>